export default __webpack_public_path__ + "static/media/agreement.2df253d5.svg";